module.exports = __webpack_public_path__ + "static/map-3133964d1dc163e187a2f7c5a3f64306.svg";